export default __webpack_public_path__ + "static/media/send.9fc379c4.svg";